// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"138":"profile","161":"appointments","382":"tickets","671":"services","893":"notifications","933":"auth","962":"home"}[chunkId] || chunkId) + "." + {"138":"6e444677","161":"5522e589","382":"d1908dd3","458":"33ab6f4b","671":"b4971909","893":"2dade3ad","933":"54998ee4","962":"d75bebea"}[chunkId] + ".js";
};